import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserSessionActionCreators } from 'app/reducers/UserSessionRedux'
import { confirmVerificationCodeSuccessSelector } from 'app/selectors/user'

import useUserSessionLogger, {
  USER_SESSION_ACTION_TYPES,
} from 'components/UserSession/useUserSessionLogger'
import {
  DeviceHeader,
  DeviceFooter,
  SendVerificationCode,
  DontShareCode,
} from './Commons'
import CodeVerification from './CodeVerification'
import { CODE_VERIFICATION_TYPES } from './constants'

function RevalidateSession() {
  useUserSessionLogger(USER_SESSION_ACTION_TYPES.REVALIDATE_SESSION)

  const dispatch = useDispatch()
  const confirmSuccess = useSelector(confirmVerificationCodeSuccessSelector)

  useEffect(() => {
    if (confirmSuccess) {
      dispatch(UserSessionActionCreators.revalidateSession())
    }
  }, [confirmSuccess])

  return (
    <div data-qa="revalidate-session" className="revalidate-session">
      <DeviceHeader title="Reválida tu sesión" />

      <p style={{ textAlign: 'center' }}>
        Tu sesión ha pasado demasiado tiempo inactiva, por ello necesitamos que
        la revalides.
      </p>

      <CodeVerification
        codeVerificationType={CODE_VERIFICATION_TYPES.REVALIDATE_SESSION}
      />

      <DontShareCode />

      <DeviceFooter>
        <SendVerificationCode
          codeVerificationType={CODE_VERIFICATION_TYPES.REVALIDATE_SESSION}
        />
      </DeviceFooter>
    </div>
  )
}

export default RevalidateSession
